import React from 'react';
//react-redux comm
import { connect } from 'react-redux';
import {  } from '../../_actions';

import ViewHeader from './view-header';
import ViewContent from './view-content';

// styling
import './style.css';

//import { appHelpers } from '../../_helpers';

class Dashboard extends React.Component {
    render() {
        return (
            <div className="view">
                <ViewHeader/>
                <ViewContent/>
            </div>
        )
    }

}

function mapStateToProps(state, ownProps) {
    const { authentication } = state;
    const { user } = authentication;
    return user;
}

export default connect(mapStateToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/views/dashboard/index.js